import React, { PureComponent } from 'react'
import './styles.scss'
import { FaBars, FaGoogle } from 'react-icons/fa';
import { Container, Nav, Navbar, Form, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import { auth, firestore, signInWithGoogle, signOut } from '../firebase/firebase-utils'
import { Link } from "react-router-dom";
import KeywordList from './keywords.list'
import { Switch, Route } from 'react-router-dom'
import Query from './All/query'
import FullPost from './CRUD/fullpost'
import MyPosts from './MyPosts/index'
import All from './All/all.community'
import Saved from './saved/saved'
import { RiRestartFill } from 'react-icons/ri'

class Community extends PureComponent {
    constructor() {
        super()

        this.state = {
            User: null,
            modalShow: false,
            List: [],
            key: null,
            orderBy: 'Latest',
            category: 'FEED',
            posts: null,
            answers: [],
            isFullpost: false
        }
    }

    getPosts = (keyword) => {
        firestore.collection("answers").orderBy('order', 'desc').onSnapshot(async (querySnapshot) => {
            const query = querySnapshot.docs.map(doc => {
                return {
                    ...doc.data(), docid: doc.id
                }
            })
            this.setState({ answers: query })
        })
        firestore.collection("queries").onSnapshot((querySnapshot) => {
            var query = querySnapshot.docs.map(doc => {
                return {
                    ...doc.data(),
                    docid: doc.id
                }
            });
            query = query.filter(item => (
                item.category === this.state.category
            ))
            if (this.state.orderBy === 'Most Liked' && this.state.category === 'FEED') {
                query = query.sort((a, b) => {
                    return b.likes.length - a.likes.length
                })
                this.setState({ posts: query })
            } else {
                query = query.sort((a, b) => {
                    return b.order - a.order
                })
                this.setState({ posts: query })
            }
            if (keyword) {
                query = query.map(doc => {
                    var count = doc.keys.reduce((acc, elem) => {
                        return elem === keyword ? acc + 1 : acc
                    }, 0)
                    if (count !== 0) {
                        return doc
                    } else {
                        return 0
                    }
                })
                query = query.filter(item => item !== 0)
                this.setState({ key: keyword, posts: query })
            } else if (this.state.key !== null) {
                query = query.map(doc => {
                    var count = doc.keys.reduce((acc, elem) => {
                        return elem === this.state.key ? acc + 1 : acc
                    }, 0)
                    if (count !== 0) {
                        return doc
                    } else {
                        return 0
                    }
                })
                query = query.filter(item => item !== 0)
                this.setState({ posts: query })
                console.log(query)
            }
        })
    }

    componentDidMount = () => {
        auth.onAuthStateChanged(user => {
            this.setState({ User: user })
        })
        this.getPosts();
    }

    componentDidUpdate = () => {
        if (this.props.location.pathname === '/community' || this.props.location.pathname === '/community/saved' || this.props.location.pathname === '/community/myposts') {
            this.setState({ isFullpost: false })
        } else { this.setState({ isFullpost: true }) }
    }

    render() {
        return (
            <div className="community" >
                <Navbar className='Nav' collapseOnSelect expand="lg">
                    <Container>
                        <Navbar.Brand onClick={() => this.props.history.push('/community')} className="heading" style={{ color: '#057BD0', marginBottom: '2px', cursor: 'pointer' }}>Community Media</Navbar.Brand>
                        <Navbar.Toggle className="toogle-btn" aria-controls="responsive-navbar-nav">
                            <FaBars />
                        </Navbar.Toggle>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="ml-auto">
                                <div className="navbarSearchField">
                                    <KeywordList callBackFunction={this.getPosts.bind(this)} topKeys={false} />
                                </div>
                                <Nav.Link as={Link} to='/community' className="navlink" >Home</Nav.Link>
                                <Nav.Link as={Link} to='/' className="navlink" >Main Page</Nav.Link>
                                {this.state.User ?
                                    <>
                                        <Nav.Link className="navlink" as={Link} to="/community/myposts" >My Posts</Nav.Link>
                                        <Nav.Link className="navlink" as={Link} to="/community/saved" >Saved</Nav.Link>
                                        <Nav.Link as={Button} onClick={() => { signOut(); this.props.history.push('/community'); this.componentDidMount() }} style={{ padding: '0 20px', fontSize: '16x', borderRadius: '25px', color: '#fff', fontWeight: '600' }} >Sign Out</Nav.Link>
                                    </>
                                    :
                                    <Nav.Link as={Button} onClick={signInWithGoogle} style={{ padding: '0 20px', fontSize: '16px', borderRadius: '25px', color: '#fff', fontWeight: '600' }} ><FaGoogle style={{ marginBottom: '3px', fontSize: '18px' }} />&nbsp;&nbsp;Sign In</Nav.Link>
                                }
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Container>
                        <div className="MainDiv">
                            <div className="bodyParser">

                                {this.state.isFullpost ? null :
                                    <>
                                        {/* status  */}
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', }}>
                                            {this.state.key ?
                                                <h2 style={{ paddingTop: '20px', margin: '0 10px', fontFamily: 'Passion One', color: '#0d3d63' }}>
                                                    {this.state.key}{'  '}
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                reset keyword
                                                </Tooltip>
                                                        }
                                                    >
                                                        <span style={{ color: '#057BD0', cursor: 'pointer' }} onClick={() => { this.setState({ key: null }); this.getPosts() }}><RiRestartFill /></span>
                                                    </OverlayTrigger>
                                                </h2>
                                                : null
                                            }
                                            <div style={{ display: 'flex', float: 'right', paddingTop: '20px' }}>
                                                <Form.Control as="select" value={this.state.category} onChange={(e) => { this.setState({ category: e.target.value }); this.getPosts() }} className="select">
                                                    <option>FEED</option>
                                                    <option>QUERY</option>
                                                </Form.Control>
                                                <Form.Control as="select" onChange={(e) => { this.setState({ orderBy: e.target.value }); this.getPosts() }} className="select">
                                                    <option>Latest</option>
                                                    <option>Most Liked</option>
                                                </Form.Control>
                                            </div>
                                        </div>
                                        {/* status  */}
                                    </>
                                }

                                <Switch>
                                    <Route path='/community' exact render={() => {
                                        return (
                                            <All query={this.state.posts} />
                                        )
                                    }} />
                                    <Route path='/community/myposts' exact render={() => {
                                        return (
                                            this.state.posts ?
                                                <MyPosts query={this.state.posts.filter(post => post.uid === this.state.User.uid)} />
                                                : null
                                        )
                                    }} />
                                    <Route path='/community/saved' exact render={() => {
                                        return (
                                            this.state.posts && this.state.answers ?
                                                <Saved posts={this.state.posts} answers={this.state.answers} />
                                                : null
                                        )
                                    }} />
                                    <Route path='/community/:docid' exact component={FullPost} />
                                </Switch>
                            </div>
                            {
                                this.state.posts ?
                                    this.state.isFullpost ? null :
                                        <div className="keywordsDiv" id="keywordsDiv">
                                            <KeywordList callBackFunction={this.getPosts.bind(this)} topKeys={true} />
                                        </div> : null
                            }
                        </div>
                </Container>
                <Query user={this.state.User} />
            </div >
        )
    }
}

export default Community
